import React, { Fragment, useState, useEffect, useRef } from "react";

import { loadingVar1 } from "config/assets/animations";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown, faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { tkbTooltip } from "./data";
import { languages } from "enums/language";

const Tkb90Content = ({ data, language }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const componentRef = useRef(null);
  const tooltip = tkbTooltip[language]["TKB90"];

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (componentRef.current && !componentRef.current.contains(event.target)) {
      setIsDropdownVisible(false);
    }
  };

  let tkb = "";
  if (data === "-1") {
    if (language === "id") {
      tkb = "Gagal Memuat";
    } else {
      tkb = "Unavailable";
    }
  } else if (data instanceof Object) {
    tkb = data["tkb90"] + "%";
  }
  return (
    <div className="tkb-content inline-data" ref={componentRef}>
      <div className="inline-data">
        <div
          className="tkb90-icon"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <i className="fas fa-info-circle" />
        </div>
        <div
          className="content"
          onClick={() => setIsDropdownVisible(!isDropdownVisible)}
        >
          <p>TKB90:</p>
          {data ? <p>{tkb}</p> : <img alt="Loading" src={loadingVar1} />}
          <div className="drop-down-icon">
            {isDropdownVisible ? (
              <FontAwesomeIcon icon={faAngleUp} />
            ) : (
              <FontAwesomeIcon icon={faAngleDown} />
            )}
          </div>
        </div>
      </div>
      {isHovered && (
        <div
          className={`tkb90-tooltip ${isHovered ? "visible" : ""} ${
            isDropdownVisible ? "visibility-under-tooltip" : ""
          }`}
        >
          {tooltip}
        </div>
      )}
      <TkbDropdownContent
        data={data}
        language={language}
        isDropdownVisible={isDropdownVisible}
      />
    </div>
  );
};

const TkbDropdownContent = ({ data, language, isDropdownVisible }) => {
  const [isHovered, setIsHovered] = useState("");
  const tooltip = tkbTooltip[language][isHovered];

  return (
    <Fragment>
      <ul className={`tkb90-dropdown ${isDropdownVisible ? "visible" : ""}`}>
        <li className="inline-data-dropdown">
          <div
            onMouseEnter={() => setIsHovered("TKB60")}
            onMouseLeave={() => setIsHovered("")}
          >
            <i className="fas fa-info-circle" />
          </div>
          <p>TKB60: </p>
          {data ? (
            <p>{`${data["tkb60"]}%`}</p>
          ) : (
            <img alt="Loading" src={loadingVar1} />
          )}
        </li>
        <li className="inline-data-dropdown">
          <div
            onMouseEnter={() => setIsHovered("TKB30")}
            onMouseLeave={() => setIsHovered("")}
          >
            <i className="fas fa-info-circle" />
          </div>
          <p>TKB30: </p>
          {data ? (
            <p>{`${data["tkb30"]}%`}</p>
          ) : (
            <img alt="Loading" src={loadingVar1} />
          )}
        </li>
        <li className="inline-data-dropdown tkb-0">
          <div
            onMouseEnter={() => setIsHovered("TKB0")}
            onMouseLeave={() => setIsHovered("")}
          >
            <i className="fas fa-info-circle" />
          </div>
          <p>TKB0*: </p>
          {data ? (
            <p>{`${data["tkb0"]}%`}</p>
          ) : (
            <img alt="Loading" src={loadingVar1} />
          )}
        </li>
      </ul>
      {isHovered ? (
        <div className={`tkb0-tooltip ${isHovered !== "" ? "visible" : ""}`}>
          {tooltip}
        </div>
      ) : null}
    </Fragment>
  );
};

export { Tkb90Content, TkbDropdownContent };
